var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{style:({margin: '2rem 15rem'})})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-transition-wrap"},[_c('div',{staticClass:"css3-spinner"},[_c('div',{staticClass:"css3-spinner-bounce1"}),_c('div',{staticClass:"css3-spinner-bounce2"}),_c('div',{staticClass:"css3-spinner-bounce3"})])])
}]

export { render, staticRenderFns }